import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link/Link';
import AnchorLink from '../AnchorLink/AnchorLink';
import linkHelper from '../../helpers/linkHelper';
import ExternalLinkIcon from '../../icons/icon-external-link.svg';
import { modify } from '../../helpers/classNameHelper';


const MarkdownLinkRenderer = ({
  action,
  href,
  children,
  className,
  external,
}) => {
  const {
    allowIcon,
    href: parsedHref,
    hooks,
    openNewTab,
    scrollTo,
  } = linkHelper(href, external);

  const LinkComponent = scrollTo ? AnchorLink : Link;
  const isVisuallyExternal = openNewTab && allowIcon;

  const linkClass = modify({
    [className]: className,
    'custom-react-markdown__link': true,
  }, {
    'with-icon': isVisuallyExternal,
  });

  return (
    <LinkComponent
      action={action ? () => action(hooks) : null}
      className={linkClass}
      href={parsedHref}
      external={openNewTab}
    >
      {children}
      {isVisuallyExternal && <ExternalLinkIcon className="custom-react-markdown__link-icon" />}
    </LinkComponent>
  );
};

MarkdownLinkRenderer.propTypes = {
  action: PropTypes.func,
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  className: PropTypes.string,
  external: PropTypes.bool,
};

MarkdownLinkRenderer.defaultProps = {
  action: null,
  className: '',
  external: false,
};

export default MarkdownLinkRenderer;
